import classNames from 'classnames';
import { AppBar, Button, Card, Chip, FormControlLabel, Grid, IconButton, Radio, Tab, Tabs, Typography } from 'material-ui';
import currencyFormatter from 'currency-formatter';
import ConditionsIcon from 'material-ui-icons/Copyright';
import EuroIcon from 'material-ui-icons/EuroSymbol';
import WarningIcon from 'material-ui-icons/Warning';
import InfoIcon from 'material-ui-icons/Info';
import HighlightOffIcon from 'material-ui-icons/HighlightOff';
import KeyArrowDownIcon from 'material-ui-icons/KeyboardArrowDown';
import KeyArrowUpIcon from 'material-ui-icons/KeyboardArrowUp';
import LocationIcon from 'material-ui-icons/LocationOn';
import ServiceIcon from 'material-ui-icons/RoomService';
import PrintIcon from 'material-ui-icons/GetApp';
import BookmarkIcon from 'material-ui-icons/Bookmark';
import CardContent from 'material-ui/Card/CardContent';
import FacilitiesIcons from '../Utils/FacilitiesIcons';
import { CircularProgress } from 'material-ui/Progress';
import { withStyles } from 'material-ui/styles';
import Collapse from 'material-ui/transitions/Collapse';
import React from 'react';
import { translate } from 'react-i18next';
import { isNullOrUndefined } from 'util';
import { getValoration } from '../../services/availabilityService';
import InformationPopOver from '../../ui/InformationPopOver';
import { getUserInformation } from '../Login/loginService';
import HotelCategoryRender from '../Reservation/HotelCategoryRender';
import HotelFacilitiesRender from '../Reservation/HotelFacilitiesRender';
import HotelImagesRender from '../Reservation/HotelImagesRender';
import PriceTag from './PriceTag';
import ResultCardConditions from './ResultCardConditions';
import ResultCardMap from './ResultCardMap';
import ResultCardPrice from './ResultCardPrice';
import { netPrice } from '../../defaultValues/netPrice';
import getValue from '../../defaultValues/getValue';
import DynIcon from '../Utils/DynIcon';
import moment from 'moment';
import { compressArray } from '../Utils/shared';
import { t } from 'i18next/dist/commonjs';
import { getDefaultHeader } from '../../services/serviceAPIHelper';

const styles = theme => ({
    cardContentFix: {
        marginTop: '20px !important'
    },
    actions: {
        display: 'flex',
    },
    expand: {
        transform: 'rotate(0deg)',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
        marginLeft: 'auto',
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    photoIcon: {
        fill: '#dfdfdf',
        width: '196px',
        height: '100%',
        paddingLeft: '1em',
    },
    cardRoot: {
        position: 'relative',
        margin: '1em',
        marginRight: 0,
        marginTop: 0,
    },
    imageRoot: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        overflow: 'hidden',
        backgroundColor: theme.palette.background.paper,
    },
    hotelName: {},
    // custom tabs
    tabRoot: {
        textTransform: 'initial',
        minWidth: 72,
        fontWeight: theme.typography.fontWeightRegular,
        '&:hover': {
            color: '#dd2c00 !important',
            opacity: 1,
        },
        '&$tabSelected': {
            color: '#dd2c00 !important',
            fontWeight: 700,
        },
        '&:focus': {
            color: '#dd2c00',
        },
    },
    tabSelected: {
        borderBottom: '48px solid #dd2c00 !important',
        fontWeight: 700,
    },
    tabsIndicator: {
        backgroundColor: 'var(--primary-color)',
        height: '10px !important',
    },
    title: {
        color: theme.palette.primary.main,
    },
    hotelTitle: {
        color: 'var(--primary-color)',
    },
    availability: {
        color: theme.palette.primary.main,
        fontWeight: 500
    },
    price: {
        marginTop: '0px',
        marginBottom: '4px',
        fontWeight: 700,
        fontSize: '1.5em',
        color: theme.palette.secondary.main,
        textAlign: 'right'
    },
    priceText: {
        color: theme.palette.text.secondary,
        textAlign: 'right'
    },
    pvp: {
        color: theme.palette.primary.contrastText,
        background: '#000000', // No lo llevo al Theme porque es el único lugar donde se usa.
    },
    mealPlan: {
        color: theme.palette.primary.contrastText,
        // background: 'var(--primary-color, blue)',
        textAlign: 'center'
    },
    whiteBackground: {
        background: '#FFF'
    },
    favoriteButton: {
        color: theme.palette.primary.contrastText,
    }

});

function TabContainer(props) {
    return (
        <Typography component="div" className="tab">
            {props.children}
        </Typography>
    );
}

class ResultCard extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            expanded: false,
            tabSelected: 0,
            checkIn: this.props.query.checkInDate,
            selectedRooms: {},
            loading: false,
            imagesValidated: false,
            listMode: false
        };
        this.handleExpandClick = this.handleExpandClick.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
        this.handleOptionChange = this.handleOptionChange.bind(this);
        this.isOptionChecked = this.isOptionChecked.bind(this);
        this.calculateTotalCost = this.calculateTotalCost.bind(this);
        this.setDefaultSelection = this.setDefaultSelection.bind(this);

        this.currentUser = getUserInformation();
    }

    handleExpandClick() {
        this.setState({
            expanded: !this.state.expanded,
        });
        this.forceUpdate();
    }

    handleTabChange(event, value) {
        this.setState({
            tabSelected: value,
        });
    }

    handleOptionChange(room, opt) {
        const selectedRoom = {
            order: room.order,
            adults: room.adults,
            kids: room.kids,
            option: opt,
        };

        this.setState((prevState, props) => {
            const roomOrder = room.order;
            let selectedRooms = Object.assign({}, prevState.selectedRooms);
            selectedRooms[roomOrder] = selectedRoom;
            return {
                selectedRooms: selectedRooms,
            };
        });
    }

    isOptionChecked(room, opt) {
        const selectedRoom = this.state.selectedRooms[room.order];
        return !!(selectedRoom && selectedRoom.option.serviceCode === opt.serviceCode);
    }

    calculateTotalCost() {
        const B2bVerPVP = this.currentUser.authorities.includes('B2bVerPVP');
        let selectedOptions = Object.values(this.state.selectedRooms).map(r => r.option);
        const price = selectedOptions.reduce((acc, curr) => acc + curr.price, 0);
        const retailPrice = selectedOptions.reduce((acc, curr) => acc + curr.retailPrice, 0);
        return (
            <PriceTag
                B2bVerPVP={B2bVerPVP}
                pvp={retailPrice}
                price={price}
                showNetPrice={getValue(netPrice, this.currentUser.accountName.toLowerCase())}
            />);
    }

    // TODO: revisit this, most likely we're doing extra re-renders
    componentDidMount() {
        /**
         * VTV-384 - Expand price list only if the total results is 1.
         * VTV-454 - Expand too if the map view is active
         */
        const mustBeExpanded = this.props.isShowingFromMap ? true : this.props.totalResults === 1;
        this.setDefaultSelection(this.props.cardData);
        this.setState({ expanded: mustBeExpanded });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setDefaultSelection(nextProps.cardData);
        this.setState({ listMode: nextProps.listMode });
    }

    setDefaultSelection(cardData) {
        let defaultSelectedRooms = {};
        cardData.rooms.forEach(
            r =>
            (defaultSelectedRooms[r.order] = {
                order: r.order,
                adults: r.adults,
                kids: r.kids,
                option: r.options[0],
            }),
        );
        this.setState({
            selectedRooms: defaultSelectedRooms,
        });
    }

    gotoPrintCard = (data) => {
        let key = this.props.requestCode + '-' + data.code;
        let selectedRooms = Object.values(this.state.selectedRooms).map(r => r.option);

        let totalAdults = data.rooms.reduce((acc, r) => acc + parseInt(r.adults, 10), 0);
        let totalKids = data.rooms.reduce((acc, r) => acc + r.kids.length, 0);

        data.searchOptions = {
            adults: totalAdults,
            kids: totalKids
        };
        data.selectedRooms = selectedRooms;
        localStorage.setItem(key, JSON.stringify(data));
        window.open('/#/results/hotels/' + this.props.requestCode + '/hotelcard/' + data.code);
    }

    validateRooms = (data, method) => {
        const rooms = method && method === 'availability' ? data : data.rooms.map(room => room.options[0]);
        let hasOnRequest = false;
        const hasOnlinePay = data && data.onlinePay && data.onlinePay.pay;

        rooms.forEach((room) => {
            if (room.available === 'RQ') {
                hasOnRequest = true;
            }

        });

        const invalid = hasOnRequest && hasOnlinePay;

        if (invalid) {
            const { t } = this.props;
            alert(t('RESULTS.INVALID_PAY_AND_ONREQUEST_SELECTION'));
        }
        return !invalid;
    }

    goToReserve = () => {
        let availResponse = JSON.parse(localStorage.getItem(this.props.requestCode));

        let valuationRequest = {
            requestCode: availResponse.requestCode,
            hotelCode: this.props.cardData.code,
            checkInDate: availResponse.request.checkInDate,
            nights: availResponse.request.nights,
            rooms: Object.keys(this.state.selectedRooms).map(key => {
                let data = this.state.selectedRooms[key];
                let result = { ...data, ...data.option };
                delete result.option;
                return result;
            }),
            selectedMarket: availResponse.request.selectedMarket
        };

        const valid = this.validateRooms(valuationRequest.rooms, 'availability');

        if (valid) {
            this.setState({ loading: true });
            getValoration(valuationRequest)
                .then(result => {
                    this.setState({ loading: false });
                    const valid = this.validateRooms(result.hotels[0], 'valuation');
                    if (!valid) return;
                    if (!isNullOrUndefined(result.requestCode)) {
                        localStorage.setItem('valuationResult', JSON.stringify(result));
                        localStorage.setItem('valuationRequest', JSON.stringify(valuationRequest));
                        let loc = window.location.href.replace('/results', '');
                        window.location.href = loc + '/reserve/' + result.requestCode;
                    } else {
                        const { t } = this.props;
                        alert(t('RESULTS.UNABLE_TO_PLACE_RESERVATION'));
                        this.setState({ loading: false });
                    }
                })
                .catch(err => {
                    this.setState({ loading: false });
                });
        }

    };

    labelAvailability = value => {
        const { available, onlinePay } = value;
        const { t } = this.props;
        const labels = {
            OK: t('COMMON.PREPAYMENT_BY_CARD'),
            RQ: t('COMMON.ON_REQUEST'),
            SS: t('COMMON.STOP_SALES'),
        };
        if (available === 'RQ') {
            return (
                <span className={this.props.classes.availability} >
                    {labels[available]}
                </span>
            );
        }
        return onlinePay && onlinePay.pay ? <span>{labels[available]}</span> : '';
    };

    /**
     * This function allow to filter an array with repeated elements. It must
     * be called as callback of array.filter function.
     *
     * @param {mixed} element the current element of the array
     * @param {integer} index index of the element
     * @param {Array} elements the array to filter
     * @returns true if index of element is equal to index.
     */
    unique(element, index, elements) {
        return elements.indexOf(element) === index;
    }
    /**
     * Chequea si la seleccion del usuario tiene rooms on RQ.
     * @param {*} rooms 
     */
    hasOnRequestRooms(cardData) {
        return cardData && cardData.onrequest ? cardData.onrequest : false;
    }

    renderSelectedRooms(rooms) {
        const { classes, cardData, t } = this.props;
        let selectedOptions = Object.values(this.state.selectedRooms).map(r => r.option);
        let selectedRoomNames = [];
        // let RQ = false;
        if (selectedOptions) {
            /*  RQ = selectedOptions.some(roomoption => {
                return String(roomoption.available) === 'RQ';
            }); */
            selectedOptions.reduce((all, room) => {
                return selectedRoomNames.push(`${room.service} - ${room.description}`);
            }, []);
        }

        const countedRooms = compressArray(selectedRoomNames);
        return (
            <ul className="hotelSelectedRooms" style={{ padding: 0, listStyle: 'none'}}>
                {
                    countedRooms.map(room => {
                        return (<li>
                            <Typography style={{ display: 'flex', alignItems: 'center' }}>
                                <DynIcon icon="hotel" style={{ color: 'var(--primary-color)', marginRight: 10, }} />
                                {`${room.count}x ${room.value}`}
                            </Typography>
                        </li>);
                    })
                }
                <li className="priceSelectedRoom">
                    { this.renderSelectedPriceRoom(selectedOptions) }
                </li>
                <li>
                    <strong className={classes.title}>
                        {this.hasOnRequestRooms(cardData) ? '  -  ' + t('COMMON.ON_REQUEST') : ''}
                    </strong>
                </li>
            </ul>
        );
    }

    renderSelectedRoomMealPlan = (rooms) => {
        let selectedMealPlans = Object.values(this.state.selectedRooms).map(r => r.option.description);
        selectedMealPlans = selectedMealPlans.filter(this.unique);
        return <Typography dangerouslySetInnerHTML={{
            __html:
                selectedMealPlans.join(', ')
        }}></Typography>;
    }

    renderOffers(offers, t) {
        if (!offers) return '';
        return offers.map(o => (
            <div key={o.type}>
                {' '}
                {o.type} <br />{' '}
                {o.percentage === 'True' ? o.value + t('RESULTS.DISCOUNT') : null}
            </div>
        ));
    }

    /**
     * Indicates if Conditions tab must be shown
     * @param {Array} rooms
     * @returns {Boolean} true if Conditions tab must be shown
     */
    mustShowConditionsTab(data) {
        let rooms = data.rooms;
        let showConditions = false;
        
        if (!rooms || rooms.length === 0) {
            return false;
        }

        rooms.forEach(room => {
            room.options.forEach(option => {
                if (option.observations !== '' || option.restrictions !== '' || option.alerts !== '') {
                    showConditions = true;
                }
            });
        });

        return showConditions;

    }

    /**
     * Returns Observations and Restrictions of selected room.
     * Concatenate Observations and Restrictions with double \r\n
     * @ Returns {String}
     */
    getSelectedRoomObservationsRestrictions() {
        let observations = Object.values(this.state.selectedRooms).map(r => r.option.observations);

        let uniqueobs = observations.filter(this.unique);

        let restrictions = Object.values(this.state.selectedRooms).map(r => {
            if (r.option.restrictions) {
                return r.option.restrictions.reduce((all, res) => {
                    return all + res.name + '\r\n';
                }, '');
            }
            else {
                return [];
            }
        });

        let uniquerestrictions = restrictions.filter(this.unique);

        let alerts = Object.values(this.state.selectedRooms).map(r => r.option.alerts);

        return alerts + '\r\n' + uniqueobs.join('\r\n') + '\r\n\r\n' + uniquerestrictions.join('\r\n');
    }

    getHotelDescription = (cardData, lang) => {
        let data = cardData.description;
        data = data.split('\r\n').join('<br />');
        return {
            __html: data,
        };
    }


    buildTabLabel = (text, icon) => {
        return (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                <div>{icon}</div>
                {text}
            </div>
        );
    };

    state = {
        lightboxIsOpen: false,
    };

    renderShareButton(classes, cardData, t) {
        return (
            <Button className={classes.button} onClick={() => this.gotoPrintCard(cardData)}>
                <icon><PrintIcon /></icon>
            </Button>
        );
    }

    renderFavoriteButton(classes, hotelData) {
        const {isFavorite} = hotelData;
        if (isFavorite) {
            return (            
                <Button className={classes.button}  onClick={() => this.unmarkAsFavorite(hotelData)}>
                    <icon style={{color: '#003D92'}}><BookmarkIcon /></icon>
                </Button>
            );
        } else {
            return (            
                <Button  onClick={() => this.markAsFavorite(hotelData)}>
                    <icon style={{color: '#c8c5c5'}}><BookmarkIcon /></icon>
                </Button>
            );
        }
    }

    async markAsFavorite(hotelData) {
        this.props.onLoading();
        const url = `${process.env.REACT_APP_API_URL}favorites/mark`;
        const body = {hotel: hotelData, requestCode: this.props.requestCode};
        const response = await fetch(url, {
            method: 'PUT',
            body: JSON.stringify(body),
            headers: getDefaultHeader(true)
        });
        const json = await response.json();
        if (json) {
            this.props.onMarkAsFavorite();

        }

    }

    async unmarkAsFavorite(hotelData) {
        this.props.onLoading();
        const url = `${process.env.REACT_APP_API_URL}favorites/unmark`;
        const body = {hotel: hotelData, requestCode: this.props.requestCode};
        const response = await fetch(url, {
            method: 'PUT',
            body: JSON.stringify(body),
            headers: getDefaultHeader(true)
        });
        const json = await response.json();
        if (json) {
            this.props.onMarkAsFavorite();
        }
    }

    renderRecommendedHotel() {
        return (
            <div >
                <img alt="logo" src={'assets/olympia_white_logo.png'} style={{ width: '28px' }} />
            </div>
        );
    }

    closeCardButton() {

    }

    renderCloseCardButton() {
        return (
            <IconButton
                aria-label="delete"
                size="small">
                <HighlightOffIcon />
            </IconButton>
        )
    }

    getNearestCancellationFees(cancellations) {
        return cancellations.reduce((accum, cancelation) => {

            if (Object.entries(accum).length === 0) {
                accum = cancelation;
                return accum;
            }

            let dateCurrent = this.getDateFromString(cancelation.date);
            let dateAccum = this.getDateFromString(accum.date);

            if (dateCurrent < dateAccum) {
                accum = cancelation;
            }

            return accum;
        }, {});
    }

    getDateFromString(date) {
        const [day, month, year] = date.includes('/') ? date.split('/') : date.split('-');
        return new Date(+year, (+month - 1), +day);

    }

    roomDescriptions(room, opt, t) {

        let cancellationFees;
        let showTooltipCancellationFees = false;
        let labelCancellationRefund;
        let iconLabel;
        if (opt.cancelations && opt.cancelations.length > 0) {
            showTooltipCancellationFees = true;
            cancellationFees = opt.cancelations.map(cancelation => {
                let { date, cost } = cancelation;
                return <div>
                    <span>{currencyFormatter.format(cost, { code: 'EUR' })}</span>
                    &nbsp;<span>{t('COMMON.FROM_THE')}</span>
                    &nbsp;<span>{date}</span>
                </div>;
            });

        }
        const hasCancellations = opt.cancelations && Object.entries(opt.cancelations).length > 0;
        switch (true) {
            case !opt.refundable:
                labelCancellationRefund = t('COMMON.NO_REFUNDABLE');
                iconLabel = 'fees_no_refundable.png';
                break;
            case !hasCancellations:
                labelCancellationRefund = t('COMMON.CANCELLATION_FEES_NOT_AVAILABLE');
                iconLabel = 'fees_no_available.png';
                break;
            case opt.refundable && hasCancellations:
                const nearestCancellationFee = this.getNearestCancellationFees(opt.cancelations);
                labelCancellationRefund = `${t('COMMON.CANCELLATION_WITHOUT_COSTS')} ${nearestCancellationFee.date}`;
                iconLabel = 'fees_without_cost.png';
                break;
        }

        return <div style={{ marginLeft: '25px' }}>
            {/** Breaks */}
            {
                !opt.hasOwnProperty('breaksCode')
                    ? ''
                    : <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                        <img className="breaksIcon" src={'assets/icons/breaks-' + opt.breaksCode + '.svg'} />
                        {
                            !opt.breaksDescription
                                ? <Typography style={{ marginLeft: '6px' }}>
                                    <span>
                                        {opt.breaksCategory}
                                    </span>
                                </Typography>
                                : <Typography style={{ marginLeft: '6px' }}>
                                    <InformationPopOver
                                        label={opt.breaksCategory}
                                        className="breaks"
                                    >
                                        <div style={{ padding: '5px', maxWidth: '300px' }}>
                                            <small>
                                                {opt.breaksDescription}
                                            </small>
                                        </div>
                                    </InformationPopOver>
                                </Typography>
                        }
                    </div>
            }

            {/* Cancellation fees  */}
            <div style={{ display: 'flex', alignItems: 'center' }}>
                {
                    !iconLabel
                        ? ''
                        : <img className="feesIcon" src={'assets/' + iconLabel} />
                }
                {
                    !showTooltipCancellationFees ?
                        <Typography style={{ margin: '0' }}>
                            {labelCancellationRefund}
                        </Typography>

                        : <Typography style={{ margin: '0' }}>
                            <InformationPopOver
                                label={labelCancellationRefund}
                                className="Cancellation"
                            >
                                <label>{t('PROFORMA.CANCELLATION_COSTS')}</label>
                                <div style={{ padding: '5px' }}>

                                    <small>
                                        {cancellationFees}
                                    </small>

                                </div>
                            </InformationPopOver>
                        </Typography>

                }
            </div>
        </div>
    }

    renderRadioButtonColumn(room, opt, t) {
        return (
            <Grid item xs={4}>
                <FormControlLabel
                    control={
                        <Radio
                            onChange={() =>
                                this.handleOptionChange(room, opt)
                            }
                            checked={this.isOptionChecked(room, opt)}
                            value={opt.serviceCode}
                            name="radio-button-demo"
                            aria-label="A"
                            style={{ transform: 'scale(0.8)' }}
                        />
                    }
                    label={opt.service}
                />
            </Grid>
        );
    }

    renderMealplanColumn(opt, classes) {
        return (
            <Grid item xs={2}>
                {opt.description && (
                    <div>
                        <InformationPopOver
                            label={opt.description}
                            className=""
                            icon="">
                            <div className={classNames(classes.mealPlan)}>
                                <small>{opt.description}</small>
                            </div>
                        </InformationPopOver>                             
                    </div>      
                    )}
            </Grid>
        );
    }

    renderAvailabilityColumn(opt) {
        return (
            <Grid item xs={2} style={{ paddingLeft: '16px' }}>
                {this.labelAvailability(opt)}
            </Grid>
        );
    }

    renderRestrictionColumn(opt, t) {
        return (
            <Grid item xs={1}>

                {opt.restrictions ? (
                    <InformationPopOver
                        label={<WarningIcon
                            style={{
                                color: 'white',
                            }}
                        />}
                        className="Restrictions"
                        icon={
                            <InfoIcon
                                style={{
                                    color: 'white',
                                }}
                            />
                        }>
                        <small>
                            <b>{t('COMMON.RESTRICTIONS')}:</b>
                        </small>
                        <br />
                        <small>
                            {opt.restrictions.reduce((all, res) => {
                                return all + res.name;
                            }, '')}
                        </small>
                    </InformationPopOver>
                ) : (
                    ''
                )}
            </Grid>
        );
    }

    renderPriceColumn(opt, B2bVerPVP) {
        return (
            <ResultCardPrice
                price={opt.price}
                pvp={opt.retailPrice}
                B2bVerPVP={B2bVerPVP}
                showPvpIcon={B2bVerPVP && getValue(netPrice, this.currentUser.accountName.toLowerCase())}
            />
        );
    }

    renderSelectedPriceRoom(selectedOptions) {
        const {t} = this.props;
        return !selectedOptions || !selectedOptions.length ? [] :  selectedOptions.map(opt => this.roomDescriptions(null, opt, t));
    }

    renderOfferColumn(opt, t) {
        return (
            <Grid item xs={1}>
                {opt.offer !== null && opt.offer.length > 0 ? (
                    <InformationPopOver
                        label={t('RESULT_CARD.OFFER')}
                        className="Offer"
                        icon={
                            <InfoIcon
                                style={{
                                    color: 'white',
                                }}
                            />
                        }>
                        <small>{this.renderOffers(opt.offer, t)}</small>
                    </InformationPopOver>
                ) : (
                    <InformationPopOver
                        label={t('RESULT_CARD.OFFER')}
                        className="HiddenOffer"
                        icon={
                            <InfoIcon
                                style={{
                                    color: 'white',
                                }}
                            />
                        }>
                        <small>{this.renderOffers(opt.offer, t)}</small>
                    </InformationPopOver>
                )}
            </Grid>
        );
    }

    render() {
        const { classes, cardData, t, listMode, showCloseButton } = this.props;
        const { name, rooms, images, location, code, facilities } = cardData;
        const { tabSelected } = this.state;
        //OLYB2B-346 si debo mostrar o no PVP
        const B2bVerPVP = this.currentUser.authorities.includes('B2bVerPVP');
        //OLYB2B-822 - puede reservar?
        const CAN_RESERVE = !this.currentUser.authorities.includes('B2BSoloBuscador');
        const userlang = this.currentUser && this.currentUser.user_detail ?
            this.currentUser.user_detail.language.toLowerCase() : process.env.REACT_APP_DEFAULT_LANGUAGE;
        const showConditionsTab = this.mustShowConditionsTab(cardData);
        const showConditionsTabOffset = showConditionsTab ? 1 : 0;
        const showConditionsTabIndex = showConditionsTab ? 3 : -1;

        const hotel = {
            images: images ? images : [],
            code: code ? code : Math.random().toString(),

        };
        const divStyle = {
            width: listMode ? '97%' : 'calc(100% - 24.6rem)'
        };

        const contentCardClass = showCloseButton ? classes.cardContentFix : {}
        const backgroundColorHotelRecommended = cardData.recommendedHotel ? 'hotel-recommended-box' : '';

        return (
            <Card className={classes.cardRoot + " cmsResultCard " + backgroundColorHotelRecommended} >

                <CardContent className={contentCardClass} style={{ height: '100%', padding: listMode ? '1rem 1rem 0 1rem' : '0' }}>
                    {!listMode ?
                        <div>
                            <HotelImagesRender
                                imageWidth={240}
                                imageHeight={200}
                                hotel={hotel}
                                showRecommendedHotelFlag={cardData.recommendedHotel}
                            />
                        </div> :
                        <div style={{ position: 'relative', float: 'left', width: '100%', height: 'auto' }}>
                        </div>
                    }
                    <div style={divStyle}>
                        <div>
                            {this.calculateTotalCost()}
                            <Typography className={classes.priceText}>
                                {t('RESULT_CARD.PRICE_BY_NIGTH', { count: this.props.nights })}
                            </Typography>
                        </div>
                        <table className={'HotelTitleTable'}>
                            <tbody>
                                <tr>
                                    <td>
                                        <h3
                                            className={'ResultTitle ' + classes.hotelTitle} id={cardData.name}>
                                            {name}
                                        </h3>
                                        <HotelCategoryRender
                                            category={cardData ? cardData.category : null}
                                            style={{ fontSize: '14px' }}
                                        />
                                    </td>
                                    <td className={!cardData.recommendedHotel ? 'margin-without-recommended' : null}>
                                        <InformationPopOver 
                                            label={this.renderShareButton(classes, cardData, t)}>
                                            <small>
                                                {t('RESULT_CARD.SHARE_HOTEL_INFORMATION')}
                                            </small>
                                        </InformationPopOver>

                                        <InformationPopOver className={cardData.recommendedHotel ? 'recommended-margin-style' : null}
                                            label={this.renderFavoriteButton(classes, cardData)}                                            >
                                            <small>
                                                {t('RESULT_CARD.MARK_FAVORITE_HOTEL')}
                                            </small>
                                        </InformationPopOver>

                                        {cardData.recommendedHotel &&
                                            <InformationPopOver className={'recommendedHotelLogoContainer'} label={this.renderRecommendedHotel()}>       
                                            <small>
                                                {t('RESULT_CARD.RECOMMENDED_HOTEL')}
                                            </small>                 
                                            </InformationPopOver>
                                        }


                                    </td>


                                </tr>
                            </tbody>
                        </table>
                        <Typography className={classes.hotelTitle}>
                            {cardData && cardData.town ? cardData.town.townName : ''}, {cardData && cardData.state ? cardData.state.name : ''}
                            <FacilitiesIcons facilities={facilities} />
                        </Typography>
                        <p style={{marginTop: 0}}>
                            {this.renderSelectedRooms(cardData.rooms)}
                        </p>
                        {/*TODO: disabling this for the time being; designs seem
                            to assume one room selection only */}
                        <div>
                            <div>   
                            </div>
                        </div>

                        <div className="button">
                            {this.state.loading ? (
                                <CircularProgress />
                            ) :
                                (CAN_RESERVE ?
                                    <Button
                                        variant='raised'
                                        color='primary'
                                        onClick={() => this.goToReserve()}>
                                        {t('COMMON.RESERVE')}
                                    </Button>
                                    : '')
                            }
                        </div>

                        <Chip
                            label={this.state.expanded ? t('RESULT_CARD.HIDE_PRICES') : t('RESULT_CARD.VIEW_PRICES')}
                            deleteIcon={
                                this.state.expanded ? (<KeyArrowUpIcon />) : (<KeyArrowDownIcon />)
                            }
                            onDelete={this.handleExpandClick}
                            onClick={this.handleExpandClick}
                        />

                        <AppBar position="static">
                            <Tabs
                                value={tabSelected}
                                style={{ backgroundColor: 'var(--primary-color)', }}
                                classes={{ indicator: classes.tabsIndicator }}
                                onChange={this.handleTabChange}
                                onClick={this.state.expanded ? ('') : (this.handleExpandClick)}>
                                <Tab label={this.buildTabLabel(t('RESULT_CARD.TAB_PRICES'), <EuroIcon />)} />
                                <Tab label={this.buildTabLabel(t('RESULT_CARD.TAB_INFO'), <InfoIcon />)} />
                                <Tab label={this.buildTabLabel(t('RESULT_CARD.TAB_LOCATION'), <LocationIcon />)} />
                                {showConditionsTab ?
                                    <Tab label={this.buildTabLabel(t('RESULT_CARD.TAB_CONDITIONS'), <ConditionsIcon />)} /> : ''
                                }
                                {cardData.facilities && cardData.facilities.length > 0 ?
                                    <Tab label={this.buildTabLabel(t('RESULT_CARD.TAB_SERVICES'), <ServiceIcon />)} /> : ''
                                }
                            </Tabs>
                        </AppBar>
                    </div>
                </CardContent>
                <Collapse in={this.state.expanded} timeout={0} unmountOnExit>
                    <CardContent className={classes.whiteBackground}>
                        <div className={classes.root}>

                            {tabSelected === 0 && (
                                <TabContainer>
                                    {rooms.map((room, idx) => {
                                        return (
                                            <div key={idx}>
                                                <Typography
                                                    style={{
                                                        fontWeight: '700',
                                                        fontSize: '16px',
                                                        height: '33px',
                                                        paddingTop: (idx > 0) ? '16px' : ''
                                                    }}>
                                                    {t('RESULT_CARD.ROOM_POS', { pos: idx + 1 })}
                                                </Typography>
                                                {room.options.map((opt, idx2) => {
                                                    const hasOffer = opt.offer !== null && opt.offer.length > 0;
                                                    const rowClass = classNames({
                                                        'roomRow active': this.isOptionChecked(room, opt) && !hasOffer,
                                                        'roomRow active offerRow': this.isOptionChecked(room, opt) && hasOffer,
                                                        'roomRow': !this.isOptionChecked(room, opt) && !hasOffer,
                                                        'roomRow offerRow': !this.isOptionChecked(room, opt) && hasOffer
                                                    });
                                                    return (
                                                        <div>
                                                            <Grid
                                                                container
                                                                style={{ paddingBottom: '10px' }}
                                                                className={rowClass}
                                                                key={idx2}>
                                                                {/*
                                                                    RADIOBUTTON / ROOM TYPE
                                                                */}
                                                                {this.renderRadioButtonColumn(room, opt, t)}

                                                                {/*
                                                                    MEALPLAN
                                                                */}
                                                                {this.renderMealplanColumn(opt, classes)}

                                                                {/*
                                                                    AVAILABLE
                                                                */}
                                                                {this.renderAvailabilityColumn(opt)}

                                                                {/*
                                                                    RESTRICTIONS
                                                                */}
                                                                {this.renderRestrictionColumn(opt, t)}

                                                                {/*
                                                                    OFFER
                                                                */}
                                                                {this.renderOfferColumn(opt, t)}

                                                                {/*
                                                                    PRICE
                                                                */}
                                                                {this.renderPriceColumn(opt, B2bVerPVP)}

                                                            </Grid>
                                                            <div className={rowClass + ' roomDescription'} style={{ width: '100%', paddingTop: 0 }}>
                                                                <span>
                                                                    {this.roomDescriptions(room, opt, t)}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        );
                                    })}
                                </TabContainer>
                            )}
                            {tabSelected === 1 && (
                                <TabContainer>
                                    <div>
                                        <article
                                            dangerouslySetInnerHTML={this.getHotelDescription(cardData, userlang)}
                                        />
                                    </div>
                                </TabContainer>
                            )}
                            {/*tabSelected === 2 &&
                                images && (
                                <TabContainer>
                                    <div>
                                        <ResultCardPhotos images={images} />
                                    </div>
                                </TabContainer>
                                    )*/}
                            {tabSelected === 2 &&
                                <TabContainer>
                                    <div>
                                        {
                                            location && (
                                                <ResultCardMap
                                                    center={location}
                                                    zoom={11}
                                                />)

                                        }
                                    </div>
                                </TabContainer>
                            }
                            {tabSelected === showConditionsTabIndex && showConditionsTab && (
                                <TabContainer>
                                    <div>
                                        <ResultCardConditions data={this.getSelectedRoomObservationsRestrictions()} />
                                    </div>
                                </TabContainer>
                            )}
                            {tabSelected === (3 + showConditionsTabOffset) && cardData.facilities &&
                                <HotelFacilitiesRender hotel={cardData} language={userlang} />
                            }
                            <div className="button button-rates" style={{ float: 'right', paddingTop: '1.8rem' }}>
                                {this.state.loading ? (
                                    <CircularProgress />
                                ) :
                                    (CAN_RESERVE ?
                                        <Button
                                            variant='raised'
                                            color='primary'
                                            onClick={() => this.goToReserve()}>
                                            {t('COMMON.RESERVE')}
                                        </Button>
                                        : '')
                                }
                            </div>
                        </div>
                    </CardContent>
                </Collapse>
                {/* This button is showed when the map is active */}
                {
                    showCloseButton && (
                        <span onClick={() => this.props.onRemoveHotel(this.props.cardPosition)} style={{ position: 'absolute', top: 0, right: 0, cursor: 'pointer' }}>
                            <InformationPopOver
                                position='left'
                                label={this.renderCloseCardButton()}>
                                <small>
                                    {t('RESULT_CARD.REMOVE_FROM_LIST')}
                                </small>
                            </InformationPopOver>
                        </span>

                    )

                }
            </Card >
        );
    }
}

ResultCard.defaultProps = {
    showCloseButton: false,
    isShowingFromMap: false
}

export default translate('translations')(withStyles(styles)(ResultCard));



// WEBPACK FOOTER //
// ./src/components/Results/ResultCard.js